import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { DialogDisclosure } from 'reakit';
import { Button } from '../Button';
import { useModalContext } from './Modal.Context';

function ModalTrigger(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, forwardedRef),
      _useContextSystem$as = _useContextSystem.as,
      as = _useContextSystem$as === void 0 ? Button : _useContextSystem$as,
      otherProps = _objectWithoutProperties(_useContextSystem, ["as"]);

  var _useModalContext = useModalContext(),
      dialog = _useModalContext.dialog;

  return /*#__PURE__*/React.createElement(DialogDisclosure, Object.assign({
    ref: forwardedRef
  }, dialog, {
    as: as
  }, otherProps));
}

export default contextConnect(ModalTrigger, 'ModalTrigger');